import { createAction, props } from "@ngrx/store";
export const setGenericDocCashbookListing_State = createAction(
  "[Column 1 View Model] Set Generic Doc Cashbook Listing State",
  props<{ genericDocCashbookListingState: any }>()
);